import React, { Fragment } from "react";

import Lozange from "../../../../ui-elements/lozenge/lozenge";
export default function BillingInformationPrimaryLozenge({title, color}) {
	return (
		<Fragment>
            <Lozange title={title} color={color} />
		</Fragment>
	);
}